import { IntentType } from '@40seas/entities/intents';
import { SetupUrls } from '@40seas/frontend/libs/entities';
import { LocaleType } from '@40seas/frontend/libs/providers';
import { FlowConfiguration, PaymentContextType } from '@40seas/payments-shared';

export const initilizeIntentConfiguration = (
    data: PaymentContextType,
    intentType: IntentType,
    isSeller: boolean,
    urls: SetupUrls,
    locale: LocaleType,
): FlowConfiguration => {
    const isOnboarding = [IntentType.Checkout, IntentType.Invoice, IntentType.Onboard].includes(intentType);

    const isAutoSearchBusinessEnabled = [IntentType.CreditLine].includes(intentType);

    const returnedEntity = getReturnedEntityByIntentType(intentType);

    return {
        isSeller,
        isOnboarding,
        isAutoSearchBusinessEnabled,
        returnedEntity,
        shouldStartDirectDebit: [IntentType.BuyerInvoice, IntentType.Invoice, IntentType.Checkout].includes(intentType),
        allowSkippingCreditLineRequest: ![IntentType.CreditLine, IntentType.BuyerSignup, IntentType.Onboard].includes(intentType),
        allowSkippingFinancialConnection: [IntentType.CreditLine].includes(intentType),
        //@ts-ignore - Fix TS FS-3199
        urls,
        locale,
    };
};

function getReturnedEntityByIntentType(intentType: IntentType): FlowConfiguration['returnedEntity'] {
    const intentTypeToReturnedEntity = {
        [IntentType.Onboard]: 'buyer',
        [IntentType.BuyerSignup]: 'buyer',
        [IntentType.CreateBuyer]: 'buyer',

        [IntentType.CreditLine]: 'creditLine',

        [IntentType.Checkout]: 'checkout',

        [IntentType.Invoice]: 'invoice',

        [IntentType.BuyerInvoice]: 'invoice',

        [IntentType.PaymentLink]: 'invoice',
    };

    return (intentTypeToReturnedEntity as any)[intentType] as FlowConfiguration['returnedEntity'];
}
